// extracted by mini-css-extract-plugin
export default {"author":"post_author__LR3pb","image":"post_image__7dAOa","date":"post_date__H16UQ"};